<template>
  <div class="row">
    <div class="col-8">
      <BreadCrumb :page="page" />
    </div>
    <div class="col-4 text-right mt-3">
      <ActionButton
        i="fas fa-arrow-circle-left"
        variant="outline-success m-2"
        @click="back"
      >
        Regresar
      </ActionButton>
      <ActionButton i="fas fa-flag" variant="success m-2" @click="save(true)">
        Guardar
      </ActionButton>
      <ActionButton
        i="fas fa-save"
        variant="outline-success m-2"
        @click="save(false)"
      >
        Historial
      </ActionButton>
    </div>
    <div class="col-12">
      <div class="dropdown-divider pb-2 w-100 mb-4" />
      <div class="tab-content">
        <div class="col">
          <ControversyErrorBox
            message="Información Incompleta"
            :is-visible="hasValidationError"
          />
        </div>
        <div class="col mt-5">
          <SectionTitle
            content="Definiciones para puntuaciones de indicadores apropiadas a la edad"
            :has-line="true"
          />
          <!-- BEGIN -->
          <tr class="row mx-2">
            <td class="col-md-12 p-0">
              <Accordion id="scaleAccordion">
                <AccordionItem
                  id="psa"
                  key="ddd"
                  title="Información de Escala de Evaluación"
                >
                  <div slot="content">
                    <div class="row ml-0">
                      <div class="question-box question-box-7">
                        7
                      </div>
                      <div class="question-line col mt-3">
                        <span>Completamente</span>
                        <p class="font-weight-lighter">
                          Muestra funcionamiento esperado para su edad o casi
                          todas las situaciones de su diario vivir. Su
                          funcionamiento es apropiado a su edad. No hay
                          preocupaciones sobre el funcionamiento de el/la
                          niño(a) en estas áreas de indicaciones.
                        </p>
                      </div>
                    </div>
                    <div class="row ml-0">
                      <div class="question-box question-box-6">
                        6
                      </div>
                      <div class="question-line col mt-3">
                        <p class="font-weight-lighter mt-3">
                          Entre “Completamente” y “A veces”. Su funcionamiento
                          es generalmente considerado como apropiado para su
                          edad, pero existen algunas preocupaciones sobre el
                          funcionamiento de el/la niño(a) en este indicador.
                        </p>
                      </div>
                    </div>
                    <div class="row ml-0">
                      <div class="question-box question-box-5">
                        5
                      </div>
                      <div class="question-line col mt-3">
                        <span>A veces</span>
                        <p class="font-weight-lighter">
                          Muestra funcionamiento esperado para su edad en
                          algunos momentos o algunas situaciones. Su
                          funcionamiento fluctúa entre apropiado y no apropiado.
                          Su funcionamiento puede ser descrito como el de un(a)
                          niño(a) ligeramente menor.
                        </p>
                      </div>
                    </div>
                    <div class="row ml-0">
                      <div class="question-box question-box-4">
                        4
                      </div>
                      <div class="question-line col mt-3">
                        <p class="font-weight-lighter mt-4">
                          Entre “A veces” y “Comenzando”.
                        </p>
                      </div>
                    </div>
                    <div class="row ml-0">
                      <div class="question-box question-box-3">
                        3
                      </div>
                      <div class="question-line col mt-3">
                        <span>Comenzando</span>
                        <p class="font-weight-lighter">
                          Aún no muestra funcionamiento esperado para un(a)
                          niño(a) de su edad en ninguna situación. Su conducta y
                          destreza incluyen destrezas fundamentales sobre las
                          que puede construir funcionamiento apropiado a su
                          edad. Su funcionamiento puede describirse como el de
                          un(a) niño(a) menor.
                        </p>
                      </div>
                    </div>
                    <div class="row ml-0">
                      <div class="question-box question-box-2">
                        2
                      </div>
                      <div class="question-line col mt-3">
                        <p class="font-weight-lighter mt-4">
                          Entre “Comenzando” y “Aún no”.
                        </p>
                      </div>
                    </div>
                    <div class="row ml-0">
                      <div class="question-box question-box-1">
                        1
                      </div>
                      <div class="question-line col mt-3">
                        <span>Aún No</span>
                        <p class="font-weight-lighter">
                          Aún no muestra un funcionamiento esperado para un(a)
                          niño(a) de su edad en ninguna situación. Su conducta y
                          destreza aún no incluyen ninguna destreza básica sobre
                          la que pueda construir funcionamiento apropiado a su
                          edad. Su funcionamiento puede ser descrito como el de
                          un(a) niño(a) significativamente menor.
                        </p>
                      </div>
                    </div>
                  </div>
                </AccordionItem>
              </Accordion>
            </td>
          </tr>
          <!-- END -->
        </div>

        <div class="col mt-5">
          <SectionTitle
            content="1. Destrezas socio emocionales positivas (incluyendo relaciones sociales)"
            :has-line="true"
          />
          <div class="row mb-3 px-5">
            Para completar los siguientes encasillados, piense en el
            funcionamiento del niño/a en las siguientes áreas y otras
            relacionadas (Según indicado por los assessments y basado en
            observaciones de aquellas personas en contacto directo con el
            niño/a).
            <div class="col-12 pt-4">
              <p>
                <i class="far fa-check text-green mx-2" />
                <span class="font-weight-lighter">
                  Relacionarse con adultos
                </span>
              </p>
              <p>
                <i class="far fa-check text-green mx-2" />
                <span class="font-weight-lighter">
                  Relacionarse con otros niños/as
                </span>
              </p>
              <p>
                <i class="far fa-check text-green mx-2" />
                <span class="font-weight-lighter">
                  Interactuar con otros y seguir normas sociales relacionadas a
                  actividades de grupos (si es mayor de 18 meses)
                </span>
              </p>
            </div>
          </div>
          <div class="row text-center pre-line mx-2 mb-3">
            <div class="col">
              PRE
            </div>
          </div>
          <div class="row mb-3 px-4">
            <div class="col-12">
              <WizardQuestion
                id="qPreQuestionsA"
                key="1"
                description="¿En qué medida este niño/a demuestra funcionamiento apropiado a su edad, a través de una variedad de ambientes y situaciones en este indicador?"
                :has-icon="false"
                :answer-control-type="5"
                error-message="mensaje"
                bold-text
                sub-number="1"
                :default-option-value-selected="1"
                display-number="1"
                no-border
                :get-options="getRadioButtonOptions"
              />
            </div>
          </div>
          <!-- Evidencia -->
          <div class="row mt-3 px-5">
            <div class="col-12">
              Evidencia para 1.a.
              <div class="row">
                <div class="col-md-4 mt-3">
                  <ValidationProvider v-slot="{ errors }" rules="required">
                    <CustomDropDown
                      label="Fuente:"
                      regular-label
                      placeholder="Seleccionar"
                      fieldkey="id"
                      required
                      fieldname="description"
                      :options="academicYears"
                      :disabled="formMode == 2"
                      :error="errors[0]"
                      :custom-error-msg="errorMsgs['SelectAcademicYears']"
                    />
                  </ValidationProvider>
                </div>
                <div class="col-md-2 mt-3">
                  <ValidationProvider v-slot="{ errors }" rules="required">
                    <CustomDatePicker
                      label="Fecha:"
                      regular-label
                      :value="model.evalDiscussionDate"
                      :disabled="readonly"
                      @onSelectedDate="onDateChanged"
                    />
                  </ValidationProvider>
                </div>
              </div>
              <div class="row">
                <div class="col mt-4">
                  <CustomTextArea
                    v-model="info.comment"
                    :rows="4"
                    regular-label
                    label="Resumen de resultados relevantes:"
                    :maxlength="500"
                    placeholder="Escribe aquí..."
                    :show-char-count="false"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- END: Evidencia -->
        </div>
        <div class="col mt-5">
          <SectionTitle
            content="2. Adquisición y uso de conocimiento y destrezas"
            :has-line="true"
          />
          <div class="row mb-3 px-5">
            Para completar los siguientes encasillados, piense en el
            funcionamiento del niño/a en las siguientes áreas y otras
            relacionadas (Según indicado por los assessments y basado en
            observaciones de aquellas personas en contacto directo con el
            niño/a).
            <div class="col-12 pt-4">
              <p>
                <i class="far fa-check text-green mx-2" />
                <span class="font-weight-lighter">
                  Relacionarse con adultos
                </span>
              </p>
              <p>
                <i class="far fa-check text-green mx-2" />
                <span class="font-weight-lighter">
                  Relacionarse con otros niños/as
                </span>
              </p>
              <p>
                <i class="far fa-check text-green mx-2" />
                <span class="font-weight-lighter">
                  Interactuar con otros y seguir normas sociales relacionadas a
                  actividades de grupos (si es mayor de 18 meses)
                </span>
              </p>
            </div>
          </div>
          <div class="row text-center pre-line mx-2 mb-3">
            <div class="col">
              PRE
            </div>
          </div>
          <div class="row mb-3 px-5">
            <div class="col-12">
              <WizardQuestion
                id="qPreQuestionsB"
                key="1"
                description="¿En qué medida este niño/a demuestra funcionamiento apropiado a su edad, a través de una variedad de ambientes y situaciones en este indicador?"
                :has-icon="false"
                sub-number="2"
                :answer-control-type="5"
                bold-text
                error-message="mensaje"
                :default-option-value-selected="1"
                display-number="2"
                no-border
                :get-options="getRadioButtonOptions"
              />
            </div>
          </div>
          <!-- Evidencia -->
          <div class="row mt-3 px-5">
            <div class="col-12">
              Evidencia para 2.a.
              <div class="row">
                <div class="col-md-4 mt-3">
                  <ValidationProvider v-slot="{ errors }" rules="required">
                    <CustomDropDown
                      label="Fuente:"
                      regular-label
                      placeholder="Seleccionar"
                      fieldkey="id"
                      required
                      fieldname="description"
                      :options="academicYears"
                      :disabled="formMode == 2"
                      :error="errors[0]"
                      :custom-error-msg="errorMsgs['SelectAcademicYears']"
                    />
                  </ValidationProvider>
                </div>
                <div class="col-md-2 mt-3">
                  <ValidationProvider v-slot="{ errors }" rules="required">
                    <CustomDatePicker
                      label="Fecha:"
                      regular-label
                      :value="model.evalDiscussionDate"
                      :disabled="readonly"
                      @onSelectedDate="onDateChanged"
                    />
                  </ValidationProvider>
                </div>
              </div>
              <div class="row">
                <div class="col mt-4">
                  <CustomTextArea
                    v-model="info.comment"
                    :rows="4"
                    label="Resumen de resultados relevantes:"
                    :maxlength="500"
                    regular-label
                    placeholder="Escribe aquí..."
                    :show-char-count="false"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- END: Evidencia -->
        </div>
        <div class="col mt-5">
          <SectionTitle
            content="3. Toma de acciones para suplir una necesidad"
            :has-line="true"
          />
          <div class="row mb-3 px-5">
            Para completar los siguientes encasillados, piense en el
            funcionamiento del niño/a en las siguientes áreas y otras
            relacionadas (Según indicado por los assessments y basado en
            observaciones de aquellas personas en contacto directo con el
            niño/a).
            <div class="col-12 pt-4">
              <p>
                <i class="far fa-check text-green mx-2" />
                <span class="font-weight-lighter">
                  Relacionarse con adultos
                </span>
              </p>
              <p>
                <i class="far fa-check text-green mx-2" />
                <span class="font-weight-lighter">
                  Relacionarse con otros niños/as
                </span>
              </p>
              <p>
                <i class="far fa-check text-green mx-2" />
                <span class="font-weight-lighter">
                  Interactuar con otros y seguir normas sociales relacionadas a
                  actividades de grupos (si es mayor de 18 meses)
                </span>
              </p>
            </div>
          </div>
          <div class="row text-center pre-line mx-2 mb-3">
            <div class="col">
              PRE
            </div>
          </div>
          <div class="row mb-3 px-5">
            <div class="col-12">
              <WizardQuestion
                id="qPreQuestionsC"
                key="1"
                description="¿En qué medida este niño/a demuestra funcionamiento apropiado a su edad, a través de una variedad de ambientes y situaciones en este indicador?</span>"
                :has-icon="false"
                bold-text
                sub-number="3"
                :answer-control-type="5"
                error-message="mensaje"
                :default-option-value-selected="1"
                display-number="3"
                no-border
                :get-options="getRadioButtonOptions"
              />
            </div>
          </div>
          <!-- Evidencia -->
          <div class="row mt-3 px-5">
            <div class="col-12">
              Evidencia para 3.a.
              <div class="row">
                <div class="col-md-4 mt-3">
                  <ValidationProvider v-slot="{ errors }" rules="required">
                    <CustomDropDown
                      label="Fuente:"
                      regular-label
                      placeholder="Seleccionar"
                      fieldkey="id"
                      required
                      fieldname="description"
                      :options="academicYears"
                      :disabled="formMode == 2"
                      :error="errors[0]"
                      :custom-error-msg="errorMsgs['SelectAcademicYears']"
                    />
                  </ValidationProvider>
                </div>
                <div class="col-md-2 mt-3">
                  <ValidationProvider v-slot="{ errors }" rules="required">
                    <CustomDatePicker
                      label="Fecha:"
                      regular-label
                      :value="model.evalDiscussionDate"
                      :disabled="readonly"
                      @onSelectedDate="onDateChanged"
                    />
                  </ValidationProvider>
                </div>
              </div>
              <div class="row">
                <div class="col mt-4">
                  <CustomTextArea
                    v-model="info.comment"
                    :rows="4"
                    label="Resumen de resultados relevantes:"
                    regular-label
                    :maxlength="500"
                    placeholder="Escribe aquí..."
                    :show-char-count="false"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- END: Evidencia -->
        </div>
        <div v-if="mode !== 'resolution'" class="col separator">
          <ControversyAgreement
            v-if="controversyData"
            :is-terms-accepted="terms"
            :disabled="isControversyResolvedOrSubmitted"
            :is-required="hasValidationError"
            @termsChecked="termsChecked"
          />
        </div>
        <div class="col separator">
          <div class="float-right mt-4">
            <ActionButton
              i="fas fa-save"
              variant="success m-2"
              @click="save(false)"
            >
              Guardar
            </ActionButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ActionButton,
  CustomTextArea,
  CustomDropDown,
} from '@/components/common';
import BreadCrumb from '@/components/common/page/TitleBreadcrumb';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import { SectionTitle } from '@/components/pei/shared';
import mixAlert from '@/mixin/alert.mixin';
import resourcesService from '@/services/resources.js';
import WizardQuestion from '@/components/pei/WizardQuestion';
import { ValidationProvider } from 'vee-validate';
import { Accordion, AccordionItem } from '@/components/pei/shared/accordion';

import {
  ControversyAgreement,
  ControversyErrorBox,
} from '@/components/pei/controversy/components';
import store from '@/store/index';

const SectionVIII = 7;

export default {
  mixins: [mixAlert],
  components: {
    BreadCrumb,
    ActionButton,
    SectionTitle,
    ControversyAgreement,
    ControversyErrorBox,
    WizardQuestion,
    ValidationProvider,
    CustomDatePicker,
    CustomTextArea,
    CustomDropDown,
    Accordion,
    AccordionItem,
  },
  data() {
    return {
      sources: [],
      errorMsgs: {
        nombre: 'Favor de entrar el nombre.',
        categoria: 'Favor de selecional una categoría.',
        document: 'Favor de anejar el documento.',
        errorOnSaving: 'Se ha producido un error al guardar el documento',
        missingFields: 'Se requiere completar todos los campos para continuar',
      },
      info: {
        name: '',
        category: null,
        files: null,
        document: null,
      },
      isAddMode: false,
      model: {
        peiStatusCode: 0,
      },
      peiId: store.getters.SelectedPei,
      page: {
        icon: 'fas fa-user-edit',
        title: 'Cuestionario Intervención',
        routes: ['Inicio', 'Estudiante', 'Cuestionario de Intervención'],
        sections: ['I. Documentos de la Controversia'],
      },
      methods: {
        fetch: `api/pei/attachments/${store.getters.SelectedPei}`,
        upload: `api/pei/uploaddocument`,
        update: `api/pei/updatedocument`,
        delete: `/api/pei/deletedocument?id=`,
      },
      menuItems: [
        {
          iconClass: 'fas text-green fa-file-alt mr-1',
          method: 'downloadFile',
          text: 'Descargar',
        },
        {
          iconClass: 'fas text-green fa-pencil-alt mr-1',
          method: 'editFile',
          text: 'Editar',
        },
        {
          iconClass: 'fas text-red fa-times-circle mr-1',
          method: 'showConfirmationDelete',
          text: 'Eliminar',
          dataAttributes: {
            'data-toggle': 'modal',
            'data-target': '#popup',
          },
        },
      ],
      documentCodeType: 'PeiControversyDocument',
      allowedFiles: '.pdf',
      requiredDocumentTypes: [28, 178],
      excludeFromDocumentsType: [
        this.$route.params.mode !== 'resolution' ? 29 : 28,
      ],
      addNewDocument: false,
      hasValidationError: false,
      controversyList: [],
      additionalInfoList: [],
      documentsList: [
        {
          id: 1,
          date: '31/ene/2020',
          type: 'Minuta - Controversia',
          title: 'Documento del PEI',
          comment: 'Comentario sobre el documento del PEI.',
        },
        {
          id: 2,
          date: '31/ene/2020',
          type: 'Minuta - Controversia',
          title: 'Documento del PEI',
          comment: 'Comentario sobre el documento del PEI.',
        },
        {
          id: 3,
          date: '31/ene/2020',
          type: 'Minuta - Controversia',
          title: 'Documento del PEI',
          comment: 'Comentario sobre el documento del PEI.',
        },
      ],
      documentTypeList: [{ id: 1, title: 'PEI Document' }],
      controversyData: undefined,
      terms: false,
      resources: [],
      documents: [],
      mode: this.$route.params.mode || 'controversy',
      isControversyResolvedOrSubmitted: false,
    };
  },
  created() {
    this.loadControversyList();
    this.loadResources();
  },
  computed: {
    list: function() {
      return this.additionalInfoList;
    },
  },
  methods: {
    termsChecked(value) {
      this.terms = value;
    },
    onAddDocumentHandler() {
      this.addNewDocument = true;
    },
    onSaveDocumentHandler(item) {
      this.addNewDocument = false;
      this.documentsList.push({
        id: this.documentsList[this.documentsList.length - 1].id + 1,
        date: '31/ene/2020',
        type: item.type.title,
        title: 'Documento del PEI',
        comment: item.comment,
      });
    },
    getSavedDocuments(documents) {
      this.documents = documents;
    },
    getMenuItems(isSubmitted) {
      this.menuItems = isSubmitted
        ? this.menuItems.filter((x) => x.text === 'Descargar')
        : this.menuItems;
    },
    loadControversyList() {
      this.$ApiGet(`/api/pei/${this.peiId}/controversies`)
        .then((res) => {
          this.controversyData = res.data;
          this.isControversyResolvedOrSubmitted =
            this.mode !== 'resolution'
              ? res.data.isSubmitted
              : res.data.isResolved;
          this.terms = res.data.isSubmitted;
          this.getMenuItems(res.data.isSubmitted);
          this.additionalInfoList = [
            {
              id: 1,
              number: 1,
              title: '¿El PEI fue aprobado parcialmente?',
              answer: res.data.peiPartiallyApprovedAnswer,
              comment: '',
              parentQuestion: null,
            },
            {
              id: 2,
              number: 2,
              title:
                'El PEI aprobado parcialmente, ¿requería servicios relacionados?',
              answer:
                res.data.peiPartiallyApprovedAnswer !== null &&
                res.data.peiPartiallyApprovedAnswer === true
                  ? res.data.relatedServiceRequiredAnswer
                  : null,
              comment: '',
              parentQuestion: {
                relatedQuestionId: 1,
                relatedValue: res.data.peiPartiallyApprovedAnswer,
                requiredValue: true,
              },
            },
            {
              id: 3,
              number: 3,
              title:
                'El PEI aprobado parcialmente, ¿continuó recibiendo servicios relacionados?',
              answer:
                res.data.peiPartiallyApprovedAnswer !== null &&
                res.data.peiPartiallyApprovedAnswer === true
                  ? res.data.continuedRelatedServiceAnswer
                  : null,
              comment: '',
              parentQuestion: {
                relatedQuestionId: 1,
                relatedValue: res.data.peiPartiallyApprovedAnswer,
                requiredValue: true,
              },
            },
          ];

          let _list =
            this.mode === 'resolution'
              ? res.data.peiControversySections.filter(
                  (x) => x.peiControversySectionId > 0
                )
              : res.data.peiControversySections;

          _list.forEach((element) => {
            let serviceSectionDescription = '';
            if (element.sectionId == SectionVIII) {
              serviceSectionDescription = `Si la controversia en la parte ${element.sectionName} es con los Servicios Relacionados, seleccione cuales:`;
            }

            let partOfPei = {
              id: element.sectionId,
              peiControversySectionId: element.peiControversySectionId,
              number: element.sortOrder,
              displayNumber: `${element.sectionName}`,
              title: `${element.sectionDescription}`,
              requireErrorCode: '',
              requireErrorMessage: 'Favor de contestar si existe controversia.',
              fields: [],
              answer: element.sectionControversyAnswer,
              comment: element.sectionControversyComment,
              serviceSectionDescription: serviceSectionDescription,
              viewSectionControversyComment:
                element.viewSectionControversyComment,
              resolvedControversyList: element.resolvedControversyList,
              parentQuestion: null,
            };

            if (element.servicesList != null) {
              element.servicesList.forEach((service) => {
                partOfPei.fields.push({
                  description: service.description,
                  id: service.id,
                  selected: service.selected,
                });
              });
            }

            this.controversyList.push(partOfPei);
          });
        })
        .catch((err) => {
          this.response = err;
        });
    },
    back() {
      this.$router.push({ path: '/pei/detail' });
    },
    getRadioButtonOptions() {
      let dropdownOptions = [
        { value: 1, option: '1', selected: false },
        { value: 2, option: '2', selected: false },
        { value: 3, option: '3', selected: false },
        { value: 4, option: '4', selected: false },
        { value: 5, option: '5', selected: false },
        { value: 6, option: '6', selected: false },
        { value: 7, option: '7', selected: false },
      ];
      return this.resolveOptions(dropdownOptions);
    },
    resolveOptions(options) {
      let promise = new Promise(async (resolve) => {
        let optionsResponse = [];
        options.forEach((element) => {
          optionsResponse.push({
            Value: element.value ? element.value : element.option,
            Display: element.option,
            isSelected: element.selected,
          });
        });
        resolve(optionsResponse);
      });
      return promise;
    },
    save(isSubmitting) {
      isSubmitting = isSubmitting || false;
      let _mlist = this.controversyList.filter((e) => e.answer == true);
      let _list = [];

      _mlist.forEach((e) => {
        let section = this.controversyData.peiControversySections.find(
          (r) => r.sectionId == e.id
        );

        if (section) {
          section.sectionControversyAnswer = e.answer;
          section.sectionControversyComment = e.comment;
          section.servicesList = e.fields;
          _list.push(section);
        }
      });

      this.controversyData.peiControversySections = _list;

      if (this.mode !== 'resolution') {
        this.controversyData.peiPartiallyApprovedAnswer = this.additionalInfoList.find(
          (e) => e.id === 1
        ).answer;
        this.controversyData.relatedServiceRequiredAnswer = this.additionalInfoList.find(
          (e) => e.id === 2
        ).answer;
        this.controversyData.continuedRelatedServiceAnswer = this.additionalInfoList.find(
          (e) => e.id === 3
        ).answer;
      }

      let areCommentsValid = this.validateComments();

      if (!areCommentsValid) {
        this.ShowToast(
          'Alerta',
          'Favor de entrar la razón de la controversia.',
          'error'
        );
        return;
      }
      let validationAnswerResult =
        this.mode === 'resolution'
          ? this.validateResolutionAnswers()
          : this.validateAnswers();

      if (!validationAnswerResult) {
        this.ShowToast('Alerta', this.resources['0397'], 'error');
        return;
      }

      if (!this.validateControversySection()) {
        this.ShowToast(
          'Alerta',
          'Debe especificar al menos una sección en controversia',
          'error'
        );
        return;
      }

      if (this.mode !== 'resolution') {
        if (this.controversyData.peiPartiallyApprovedAnswer === null) {
          this.ShowToast('Alerta', this.resources['0397'], 'error');
          return;
        } else {
          if (this.controversyData.peiPartiallyApprovedAnswer) {
            if (
              this.controversyData.relatedServiceRequiredAnswer === null ||
              this.controversyData.continuedRelatedServiceAnswer === null
            ) {
              this.ShowToast('Alerta', this.resources['0397'], 'error');
              return;
            }
          }
        }
      }
      if (isSubmitting) {
        let attachmentTypeCode = this.mode !== 'resolution' ? 28 : 29;

        if (
          !this.documents ||
          !this.documents.some(
            (e) => e.attachmentTypeCode == attachmentTypeCode
          )
        ) {
          this.ShowToast(
            'Alerta',
            `Anejar un documento del tipo ${
              attachmentTypeCode === 28
                ? 'Minuta - Controversia'
                : 'Minuta - Resolución Controversia'
            } es requerido para guardar la controversia.`,
            'error'
          );
          return;
        }

        if (!this.terms && this.mode !== 'resolution') {
          this.ShowToast(
            'Alerta',
            'Debe aceptar los terminos y condiciones.',
            'error'
          );
          return;
        }

        this.controversyData.isSubmitted = true;
        this.isControversyResolvedOrSubmitted = true;
      }

      let url =
        this.mode === 'resolution'
          ? `/api/pei/${store.getters.PreviousPeiId}/controversies/resolve`
          : `api/pei/${this.peiId}/controversies`;

      this.$ApiPost(url, this.controversyData)
        .then(() => {
          this.ShowToast(
            '',
            'Las respuestas fueron guardadas satisfactoriamente',
            'success'
          );
        })
        .catch(() => {
          this.controversyData.isSubmitted = false;
          this.isControversyResolvedOrSubmitted = false;
        });
    },
    validateResolutionAnswers() {
      let validation = false;
      this.controversyList.forEach((x) => {
        validation = x.resolvedControversyList.some((e) => e.selected);
        this.$set(x, 'isValid', validation);
      });
      return validation;
    },
    validateAnswers() {
      // Returns true when everything is fullfiled.
      return this.controversyList.every((e) => e.answer !== null);
    },
    validateControversySection() {
      // Returns true when at least one section has controversy.
      return this.controversyList.some((e) => e.answer === true);
    },
    validateComments() {
      // Returns true if a question is answered yes and has an explanation comment.
      return this.controversyList
        .filter((e) => e.answer === true)
        .every((e) => e.comment !== '' && e.comment !== null);
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages(['0397']);
    },
  },
};
</script>

<style scoped>
.btn-tabHeader {
  font-size: 0.9em;
  margin-right: 10px;
  margin-top: 1px;
}

.btn-tabHeader-outline {
  font-weight: 500;
  margin-right: 20px;
  padding-bottom: 3px;
  padding-top: 4px;
}

.btn-tab-group {
  padding-right: 20px;
}

#btnHistory {
  height: 38px;
  border: 1px solid #2db782;
  color: #2db782;
}

#btnHistory:hover {
  background: #2db782;
  border: 1px solid #2db782;
  color: #fff;
}

.separator {
  margin-top: 60px;
}

.pre-line {
  height: 59px;
  background: #f2f2f2;
  align-items: center;
  font: Bold 25px/30px Lato;
  border-radius: 5px 5px 0px 0px;
}

.question-box {
  width: 40px;
  height: 103px;
  text-align: center;
  color: #ffffff;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: black;
  font: Bold 30px/36px Lato;
}
.question-box-7 {
  background: #a3e5b3 0% 0% no-repeat padding-box;
}
.question-box-6 {
  background: #f4f6f3 0% 0% no-repeat padding-box;
}
.question-box-5 {
  background: #f8eb7f 0% 0% no-repeat padding-box;
}
.question-box-4 {
  background: #f4f6f3 0% 0% no-repeat padding-box;
}
.question-box-3 {
  background: #fcc9c8 0% 0% no-repeat padding-box;
}
.question-box-2 {
  background: #f4f6f3 0% 0% no-repeat padding-box;
}
.question-box-1 {
  background: #d5b89a 0% 0% no-repeat padding-box;
}

.question-line.pl-55 {
  padding-left: 55px !important;
}
.question-line p {
  padding-bottom: 0px;
}

.question-line p >>> p {
  margin-bottom: 0px !important;
}
</style>
